if (typeof window.CustomBadgeResize === "undefined") {
    window.CustomBadgeResize = class {
        constructor() {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (
                        mutation.type === "childList" ||
                        mutation.type === "subtree" 
                    ) {
                        this.handleBadgeUpdate(mutation.target);
                    }
                });
            });
        }

        init() {
            // Find all carousel sliders
            const carousels = document.querySelectorAll("carousel-slider");

            carousels.forEach((carousel) => {
                // Find the Flickity instance
                const flickity = carousel.flickity;
                if (!flickity) return;

                // Observe the carousel's grid items for changes
                const gridItems = carousel.querySelectorAll(".grid-item");
                gridItems.forEach((item) => {
                    this.observer.observe(item, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                    });
                });
            });
        }

        handleBadgeUpdate(target) {
            const carousel = target.closest("carousel-slider");
            if (!carousel || !carousel.flickity) return;

            carousel.flickity.resize();
        }
    };
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.CustomBadgeResize) {
        const customBadgeResize = new window.CustomBadgeResize();
        customBadgeResize.init();
    }
});

document.addEventListener("shopify:section:load", () => {
    if (window.CustomBadgeResize) {
        const customBadgeResize = new window.CustomBadgeResize();
        customBadgeResize.init();
    }
});